import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border border-neutral-100 rounded-lg w-[320px]" }
const _hoisted_2 = { class: "flex justify-between p-6 align-middle border-b border-neutral-100" }
const _hoisted_3 = { class: "flex-1 overflow-hidden whitespace-nowrap text-ellipsis" }
const _hoisted_4 = { class: "overflow-hidden text-sm text-neutral-400 whitespace-nowrap text-ellipsis" }
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = { class: "mr-3" }
const _hoisted_7 = ["id", "name", "onUpdate:modelValue"]
const _hoisted_8 = { class: "flex-1 pr-6 overflow-hidden whitespace-nowrap text-ellipsis group" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_11 = { class: "absolute hidden px-2 py-1 text-sm text-white bg-gray-500 rounded pointer-events-none top-5 left-18 group-hover:block" }

import { ref, type PropType, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { EyeIcon, TrashIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";

import PageLoader from "@/components/loaders/PageLoader.vue"

import FormsCard from "@/views/settings/InterventionTypes/Components/Index/FormsCard.vue";
import DeleteButton from "@/views/settings/InterventionTypes/Components/Buttons/FormCard/DeleteButton.vue";

import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"

import { FormInterface } from "@/interfaces/pages/Settings/InterventionFormInterface.ts";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormsCard',
  props: {
    form: {
        type: Object as PropType<FormInterface>,
        required: true,
    },

    subForms: {
        type: Object as PropType<FormInterface[]>,
        required: true,
    }
},
  setup(__props) {

const route = useRoute();
const router = useRouter();

const props = __props;

const subForms = ref<FormInterface[]>(props.subForms);

const loaded = ref<boolean>(false);
const loading = ref<boolean>(false);

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const successMessage = ref<string>('');

const showError = ref<boolean>(false);
const errorMessage = ref<string>('');
const errors = ref<any>({});

const activeForm = ref<FormInterface>({
	id: 0,
	label: '',
	order: 0,
});

const childForms = ref<FormInterface[]>([]);


const getSubForm = (form: FormInterface):void => {

    activeForm.value = form
    loading.value = true;
    loaded.value = true

    InterventionTypeService
        .getChildForms(form.id)
        .then(({data}) => {
            childForms.value = data.children;
            loaded.value = true
        })
        .catch((error: any) => {
            console.log(error);
        })
        .finally(() => loading.value = false)
}



const save = ():void => {
    loading.value = true;
    showConfirmation.value = false;

    InterventionTypeService
        .updateChildrenOrder(
            props.form.id, 
            { children: subForms.value }
        )
        .then(({data}) => {
            showSuccess.value = true
            successMessage.value = data.message
            
            updateForm(data.data);
        })
        .catch((error: any) => {
            showError.value = true;
            errors.value = error.response.data.errors;
            errorMessage.value = error.response.data.message
        })
        .finally(() => loading.value = false)
}

const updateForm = (data: FormInterface[]): void => {
    loading.value = true;
    
    subForms.value = data;
    setTimeout(() => {
        loading.value = false;
    }, 300);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.form.label), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", {
            class: "text-sm font-semibold transition cursor-pointer text-primary-500 hover:text-primary-700",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
          }, " Save ")
        ])
      ]),
      (!loading.value)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subForms.value, (subForm, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: subForm.id,
              class: _normalizeClass(["relative flex items-center py-4 pl-6 pr-4 border-b last:border-0", [
                        activeForm.value?.id == subForm?.id ? 'bg-primary-300 ' : '',
                    ]])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: _normalizeClass(["px-1 py-2 text-sm text-center bg-transparent border rounded-lg w-9 h-9", activeForm.value?.id == subForm?.id ? 'text-primary-600 border-primary-500' : 'text-neutral-900 border-neutral-100']),
                  id: 'sort '+ subForm.label,
                  name: 'sort '+ subForm.label,
                  "onUpdate:modelValue": ($event: any) => ((subForm.order) = $event)
                }, null, 10, _hoisted_7), [
                  [_vModelText, subForm.order]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", {
                  class: _normalizeClass(["overflow-hidden text-sm whitespace-nowrap text-ellipsis", activeForm.value?.id == subForm?.id ? 'text-primary-600' : 'text-neutral-900']),
                  title: subForm.label
                }, _toDisplayString(subForm.label), 11, _hoisted_9),
                (errors.value[`children.${index}.order`])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(errors.value[`children.${index}.order`][0]), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_11, _toDisplayString(subForm.label), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center space-x-2 shrink-0", activeForm.value?.id == subForm?.id ? 'text-primary-600' : 'text-gray-500'])
              }, [
                _createVNode(_unref(EyeIcon), {
                  onClick: ($event: any) => (_unref(router).replace(`/settings/intervention-types/edit/${subForm.id}`)),
                  class: _normalizeClass(["w-5 h-5 transition cursor-pointer hover:text-secondary-500", activeForm.value?.id == subForm?.id ? 'text-primary-600' : 'text-gray-500']),
                  "aria-hidden": "true"
                }, null, 8, ["onClick", "class"]),
                _createVNode(DeleteButton, {
                  form: subForm,
                  "onDelete:success": updateForm
                }, null, 8, ["form"]),
                _createVNode(_unref(ChevronRightIcon), {
                  class: "w-5 h-5 transition cursor-pointer hover:text-primary-500",
                  "aria-hidden": "true",
                  onClick: ($event: any) => (getSubForm(subForm))
                }, null, 8, ["onClick"])
              ], 2)
            ], 2))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    (loaded.value && childForms.value.length > 0)
      ? (_openBlock(), _createBlock(FormsCard, {
          key: 0,
          form: activeForm.value,
          subForms: childForms.value
        }, null, 8, ["form", "subForms"]))
      : _createCommentVNode("", true),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (save())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Save Record",
      content: "Are you sure you wish to save form order?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
      "action-text": "Close",
      title: "Success!",
      content: successMessage.value
    }, null, 8, ["show", "content"]),
    _createVNode(ErrorModal, {
      show: showError.value,
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
      "action-text": "Close",
      title: "Error!",
      content: errorMessage.value
    }, null, 8, ["show", "content"])
  ], 64))
}
}

})